import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=7308383d"
import script from "./organization.ts?vue&type=script&lang=ts&external"
export * from "./organization.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports